import { render, staticRenderFns } from "./StairsState.vue?vue&type=template&id=bf287772&"
import script from "./StairsState.vue?vue&type=script&lang=js&"
export * from "./StairsState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports